import { gql } from 'graphql-request'

import { ScheduledCommunicationTemplatesQueries } from '../queries/scheduledCommunicationTemplates.queries'

export namespace ScheduledCommunicationTemplateMutations {
  export function createScheduledCommunicationTemplate() {
    return gql`
      mutation createScheduledCommunicationTemplate(
        $scheduledCommunicationTemplate: ScheduledCommunicationTemplateInsertMutation
      ) {
        createScheduledCommunicationTemplate(scheduledCommunicationTemplate: $scheduledCommunicationTemplate) {
          id
          createdAt
          content
          active
          marketSegment
          scheduledCommunicationType
        }
      }
    `
  }

  export function updateScheduledCommunicationTemplate() {
    return gql`
      mutation updateScheduledCommunicationTemplate(
        $scheduledCommunicationTemplate: ScheduledCommunicationTemplateUpdateMutation
      ) {
        updateScheduledCommunicationTemplate(scheduledCommunicationTemplate: $scheduledCommunicationTemplate) {
          ...ScheduledCommunicationTemplateSummary
        }
      }
      ${ScheduledCommunicationTemplatesQueries.SCHEDULED_COMMUNICATION_TEMPLATE_SUMMARY}
    `
  }
}
